import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import usePlanStore from '../../../../../../store/planStore';
import useCheckPlanName from './hooks/useCheckPlanName';
import { CheckPlanNameError } from '../../../../../../api/services/mediaPlanning/checkPlanName';
import { isCampaignNameInvalid } from './utils';

export default function CampaignNameInput() {
  const { t } = useTranslation();
  const { generalInfoState, setGeneralInfoState, savedGeneralInfoState } =
    usePlanStore((state) => ({
      generalInfoState: state.generalInfoState,
      savedGeneralInfoState: state.savedGeneralInfoState,
      setGeneralInfoState: state.setGeneralInfoState,
    }));

  const { id } = useParams();

  const { error } = useCheckPlanName();

  const errorData = error as unknown as CheckPlanNameError | undefined;
  const errorStatus = errorData?.data?.status;

  const { campaignName } = generalInfoState;
  const isDuplicateError =
    campaignName !== savedGeneralInfoState?.campaignName &&
    errorStatus === 'fail';

  // The name cannot be edited on an existing plan, so legacy names that no
  // longer match the current rules must not be flagged as invalid.
  const isInvalidName = !id && isCampaignNameInvalid(campaignName);

  let campaignHelperText = '';

  if (isInvalidName) {
    campaignHelperText = t(
      'You cannot use characters other than letters, numbers and hyphens or exceed 120 characters'
    );
  } else if (isDuplicateError) {
    campaignHelperText = t('mediaPlanning.errors.duplicatedCampaignName');
  }

  return (
    <Controller
      name="campaignName"
      render={({ field }) => (
        <TextField
          {...field}
          label={t('Campaign Name')}
          variant="outlined"
          value={generalInfoState.campaignName}
          fullWidth
          error={isDuplicateError || isInvalidName}
          helperText={campaignHelperText}
          onChange={(event) => {
            setGeneralInfoState({
              campaignName: event.target.value,
            });
          }}
          disabled={!!id}
        />
      )}
    />
  );
}
